import React from "react";

const SizeSvg = () => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5001 6.6665C17.9603 6.6665 18.3334 7.0396 18.3334 7.49984V14.1665C18.3334 14.6267 17.9603 14.9998 17.5001 14.9998H2.50008C2.03984 14.9998 1.66675 14.6267 1.66675 14.1665V7.49984C1.66675 7.0396 2.03984 6.6665 2.50008 6.6665H17.5001ZM17.0837 7.91643H2.91703V13.7498H4.37522V10.4165C4.37522 10.0713 4.65504 9.7915 5.00022 9.7915C5.31663 9.7915 5.57813 10.0266 5.61952 10.3317L5.62522 10.4165V13.7498H6.87508V11.2499C6.87508 10.9047 7.1549 10.6249 7.50008 10.6249C7.81649 10.6249 8.07799 10.86 8.11938 11.1651L8.12508 11.2499V13.7498H9.37494V10.4165C9.37494 10.0713 9.65476 9.7915 9.99994 9.7915C10.3164 9.7915 10.5779 10.0266 10.6192 10.3317L10.6249 10.4165V13.7498H11.8748V11.2499C11.8748 10.9047 12.1546 10.6249 12.4998 10.6249C12.8162 10.6249 13.0777 10.86 13.1191 11.1651L13.1248 11.2499V13.7498H14.3754V10.4165C14.3754 10.0713 14.6552 9.7915 15.0004 9.7915C15.3168 9.7915 15.5783 10.0266 15.6197 10.3317L15.6254 10.4165V13.7498H17.0837V7.91643Z"
          fill="#118BF4"
        ></path>
      </svg>
    </span>
  );
};

export default SizeSvg;
